export const surveyActionTypes = {
	UPDATE_SURVEY: "UPDATE_SURVEY",
	NEXT_QUESTION: "NEXT_QUESTION",
	PREV_QUESTION: "PREV_QUESTION",
	UPDATE_USER_DETAILS: "UPDATE_USER_DETAILS",
	SWITCH_CONSUMPTION_MODE: "SWITCH_CONSUMPTION_MODE"
};
